module.exports = __webpack_public_path__ + "img/news.61083252.svg";